module.exports = __webpack_public_path__ + "media/images/ui__arrowLeftInactive-ed4418cc56de2cad04234e8e5514f20e.png";